import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

class SettingsService {
    getOpeningHours(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getOpeningHours' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editOpeningHours(openingHoursDocument){
        let url = '/api/settings/editOpeningHours';
        let basicAuth = authHeader();
        return axios.post(url, openingHoursDocument,{
            headers: basicAuth });
    }

    getDeliveryDocument(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getDeliveryDocument' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editDeliveryDocument(deliveryDocument){
        let url = '/api/settings/editDeliveryDocument';
        let basicAuth = authHeader();
        return axios.post(url, deliveryDocument,{
            headers: basicAuth });
    }

    getClosingDays(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getClosingDays' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    deleteClosingDay(closingDay){
        let url = '/api/settings/deleteClosingDay';
        let basicAuth = authHeader();
        return axios.post(url, closingDay,{
            headers: basicAuth });
    }

    createClosingDays(closingDays){
        let url = '/api/settings/createClosingDays';
        let basicAuth = authHeader();
        return axios.post(url, closingDays,{
            headers: basicAuth });
    }

    getAnnouncements(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getAnnouncements' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    createAnnouncement(announcement){
        let url = '/api/settings/createAnnouncement';
        let basicAuth = authHeader();
        return axios.post(url, announcement,{
            headers: basicAuth });
    }

    deleteAnnouncement(announcement){
        let url = '/api/settings/deleteAnnouncement';
        let basicAuth = authHeader();
        return axios.post(url, announcement,{
            headers: basicAuth });
    }

    reopenOnlineChannel(merchant, locationId, fromDate, toDate, orderType){
        let payload = {
            merchant: merchant,
            locationId: locationId,
            fromDate: fromDate,
            toDate: toDate,
            orderType: orderType
        };
        let url = '/api/settings/deleteClosingDaysByRange';
        let basicAuth = authHeader();
        return axios.post(url, payload, {
            headers: basicAuth });
    }

    changeEarliestPickupTime(merchant, locationId, earliestPickupTime, smartPickupTimeSettings){
        let payload = {
            merchant: merchant,
            locationId: locationId,
            earliestPickupTime: earliestPickupTime
        };
        // Smart Pickup Time settings (optional)
        if (smartPickupTimeSettings) {
            payload.smartPickupTimeKrPerMinute = smartPickupTimeSettings.smartPickupTimeKrPerMinute;
            payload.smartPickupTimeMaxMinutes = smartPickupTimeSettings.smartPickupTimeMaxMinutes;
            payload.smartPickupTimeNotes = smartPickupTimeSettings.smartPickupTimeNotes;
            payload.smartPickupTimeIntentWeight = smartPickupTimeSettings.smartPickupTimeIntentWeight;
        }
        let url = '/api/settings/changeEarliestPickupTime';
        let basicAuth = authHeader();
        return axios.post(url, payload, {
            headers: basicAuth });
    }

    closeDishes(merchant, locationId){
        let payload = {
            merchant: merchant,
            locationId: locationId
        };
        let url = '/api/settings/closeDishes';
        let basicAuth = authHeader();
        return axios.post(url, payload, {
            headers: basicAuth });
    }

    openDishes(merchant, locationId){
        let payload = {
            merchant: merchant,
            locationId: locationId
        };
        let url = '/api/settings/openDishes';
        let basicAuth = authHeader();
        return axios.post(url, payload, {
            headers: basicAuth });
    }

    getVat(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getVat' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editVat(vat){
        let url = '/api/settings/editVat';
        let basicAuth = authHeader();
        return axios.post(url, vat,{
            headers: basicAuth });
    }

    getCompany(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getCompany' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editCompany(company){
        let url = '/api/settings/editCompany';
        let basicAuth = authHeader();
        return axios.post(url, company,{
            headers: basicAuth });
    }

    getSwedbankPayAccount(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getSwedbankPayAccount' + '?merchant=' + user.merchant  + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editSwedbankPayAccount(swedbankPayAccount){
        let url = '/api/settings/editSwedbankPayAccount';
        let basicAuth = authHeader();
        return axios.post(url, swedbankPayAccount,{
            headers: basicAuth });
    }

    getDinteroAccount(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getDinteroAccount' + '?merchant=' + user.merchant  + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editDinteroAccount(dinteroAccount){
        let url = '/api/settings/editDinteroAccount';
        let basicAuth = authHeader();
        return axios.post(url, dinteroAccount,{
            headers: basicAuth });
    }

    // AWS S3 connection config (CAGISTA-global, Couchbase-stored, secret encrypted) — System -> Config ->
    // S3 Config (SUPER_ADMIN). The secret key is never returned; blank secretKey on save keeps the stored one.
    getS3Config(){
        return axios.get('/api/superadmin/system/s3Config', { headers: authHeader() });
    }

    saveS3Config(payload){
        return axios.post('/api/superadmin/system/s3Config', payload, { headers: authHeader() });
    }

    // Bring (Posten) shipping config (CAGISTA-global, Couchbase-stored, API key encrypted) — System ->
    // Config -> Bring Config (SUPER_ADMIN). The API key is never returned; blank apiKey on save keeps it.
    getBringConfig(){
        return axios.get('/api/superadmin/system/bringConfig', { headers: authHeader() });
    }

    saveBringConfig(payload){
        return axios.post('/api/superadmin/system/bringConfig', payload, { headers: authHeader() });
    }

    // SaaS subscription/billing config (trial, module prices, dunning, Dintero URLs/account, manual approval)
    // — System -> Config -> Abonnement Config (SUPER_ADMIN). Couchbase-stored; nothing sensitive in it.
    getSubscriptionConfig(){
        return axios.get('/api/superadmin/system/subscriptionConfig', { headers: authHeader() });
    }

    saveSubscriptionConfig(payload){
        return axios.post('/api/superadmin/system/subscriptionConfig', payload, { headers: authHeader() });
    }

    // RustDesk remote-control config (enabled, connect-URL template, allowed policy roles) — System ->
    // Config -> RustDesk Config (SUPER_ADMIN). Couchbase-stored; fail-closed defaults (disabled, KIOSK,KDS).
    getRustdeskConfig(){
        return axios.get('/api/superadmin/system/rustdeskConfig', { headers: authHeader() });
    }

    saveRustdeskConfig(payload){
        return axios.post('/api/superadmin/system/rustdeskConfig', payload, { headers: authHeader() });
    }

    // VIVA ISV partner-onboarding config (partner OAuth creds, secret encrypted; onboarding/token URLs)
    // — System -> Config -> Viva Partner Config (SUPER_ADMIN). Blank secret on save keeps the stored one.
    getVivaPartnerConfig(){
        return axios.get('/api/superadmin/system/vivaPartnerConfig', { headers: authHeader() });
    }

    saveVivaPartnerConfig(payload){
        return axios.post('/api/superadmin/system/vivaPartnerConfig', payload, { headers: authHeader() });
    }

    // VIVA's price to merchants connected to CAGISTA (SUPER_ADMIN) — the same for every connected merchant. cagista.com
    // shows it plus the platform ISV rate; percentages as typed, amounts in øre.
    getVivaCardPrices(){
        return axios.get('/api/superadmin/system/vivaCardPrices', { headers: authHeader() });
    }

    saveVivaCardPrices(payload){
        return axios.post('/api/superadmin/system/vivaCardPrices', payload, { headers: authHeader() });
    }

    // Least-privilege machine accounts (registration / store / billing) — System -> Config -> Tjenestekontoer
    // (SUPER_ADMIN). GET lists {key, username, role, exists}; POST {key, password} sets/rotates one password.
    // Custom domain for the merchant's ordering site. Narrow endpoints on purpose: editMerchantSetting
    // upserts whatever it is handed, and this page holds only a fragment of merchant_setting.
    getCustomDomain(){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/site/customDomain?merchant=' + user.merchant, { headers: authHeader() });
    }

    setCustomDomain(host){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/site/customDomain', { merchant: user.merchant, host: host },
            { headers: authHeader() });
    }

    // SUPER_ADMIN only (/api/superadmin/**): each location's VIVA payment source and where it returns a
    // guest, shown in a box on the Eget domene page.
    getCustomDomainVivaSources(){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/superadmin/customDomainVivaSources?merchant=' + user.merchant, { headers: authHeader() });
    }

    // SUPER_ADMIN «Lag ny kilde»: a NEW VIVA source for one location, returning guests to the host they order
    // on. Answers {message, sources}.
    /** replace: a new source even when the one on file already points the right way — for one that refuses payments. */
    moveCustomDomainVivaSource(locationId, replace = false){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/superadmin/customDomainVivaSources/move',
            { merchant: user.merchant, locationId: locationId, replace: replace }, { headers: authHeader() });
    }

    getServiceAccounts(){
        return axios.get('/api/superadmin/system/serviceAccounts', { headers: authHeader() });
    }

    reconcileServiceAccountRoles(){
        return axios.post('/api/superadmin/system/serviceAccounts/reconcileRoles', {}, { headers: authHeader() });
    }

    setServiceAccountPassword(key, password){
        return axios.post('/api/superadmin/system/serviceAccounts', { key, password }, { headers: authHeader() });
    }

    // SMTP (outgoing email) config (host/port/user + password encrypted) — System -> Config -> SMTP Config
    // (SUPER_ADMIN). Password never returned; blank on save keeps the stored one.
    getSmtpConfig(){
        return axios.get('/api/superadmin/system/smtpConfig', { headers: authHeader() });
    }

    saveSmtpConfig(payload){
        return axios.post('/api/superadmin/system/smtpConfig', payload, { headers: authHeader() });
    }

    // Viva Smart Checkout PLATFORM config (environment Sandbox/Prod + token-cache TTL; derives the endpoint
    // URLs) — System -> Config -> Viva Config (SUPER_ADMIN). Global, not the per-location /viva account page.
    getVivaConfig(){
        return axios.get('/api/superadmin/system/vivaConfig', { headers: authHeader() });
    }

    saveVivaConfig(payload){
        return axios.post('/api/superadmin/system/vivaConfig', payload, { headers: authHeader() });
    }

    // Dintero config (token-cache TTL; the URLs are code constants — same sandbox/prod) — System -> Config ->
    // Dintero Config (SUPER_ADMIN). No environment switch, no secrets.
    getDinteroConfig(){
        return axios.get('/api/superadmin/system/dinteroConfig', { headers: authHeader() });
    }

    saveDinteroConfig(payload){
        return axios.post('/api/superadmin/system/dinteroConfig', payload, { headers: authHeader() });
    }

    // AI site-builder model server (vLLM/Qwen; API key encrypted) — System -> Config -> AI Modell Config
    // (SUPER_ADMIN). API key never returned; blank apiKey on save keeps the stored one.
    getSiteModelConfig(){
        return axios.get('/api/superadmin/system/siteModelConfig', { headers: authHeader() });
    }

    saveSiteModelConfig(payload){
        return axios.post('/api/superadmin/system/siteModelConfig', payload, { headers: authHeader() });
    }

    // CAGISTA's own SUBSCRIPTION-billing Dintero account (platform-global SYSTEM / SUBSCRIPTION, not a
    // merchant's). Was SYSTEM / DEVICE_STORE while the device store shared it; the store now uses VIVA.
    getSubscriptionDinteroAccount(){
        let url = '/api/settings/getDinteroAccount' + '?merchant=SYSTEM&locationId=SUBSCRIPTION';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }


    // CAGISTA's own SUBSCRIPTION-billing Swedbank Pay account (platform-global SYSTEM / SUBSCRIPTION).
    // Same key pair as the Dintero one it replaces, so switching provider does not move where credentials
    // live — only which document is read. Never a merchant's account: that is their customers' money
    // flowing the other way.
    getSubscriptionSwedbankPayAccount(){
        let url = '/api/settings/getSwedbankPayAccount' + '?merchant=SYSTEM&locationId=SUBSCRIPTION';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }


    // CAGISTA's own VIVA account for the DEVICE STORE (platform-global SYSTEM / DEVICE_STORE, not a
    // merchant's). CAGISTA is the seller there, so the account holds its own credentials — unlike a
    // merchant, who is onboarded as an ISV connected account and has none.
    getStoreVivaAccount(){
        let url = '/api/settings/getVivaAccount' + '?merchant=SYSTEM&locationId=DEVICE_STORE';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    // CAGISTA's own VIVA account for LICENCE BILLING (SYSTEM / SUBSCRIPTION). A different account from
    // the device store's above, deliberately: hardware sales and subscription income are separate revenue
    // with separate reconciliation, and the money runs in opposite directions — the store takes payment
    // from a hardware buyer, this charges a merchant. Same endpoint, different locationId.
    getSubscriptionVivaAccount(){
        let url = '/api/settings/getVivaAccount' + '?merchant=SYSTEM&locationId=SUBSCRIPTION';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editVivaAccount(vivaAccount){
        let url = '/api/settings/editVivaAccount';
        let basicAuth = authHeader();
        return axios.post(url, vivaAccount, { headers: basicAuth });
    }

    getTripletexAccount(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/getTripletexAccount' + '?merchant=' + user.merchant  + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editTripletexAccount(tripletexAccount){
        let url = '/api/tripletex/editTripletexAccount';
        let basicAuth = authHeader();
        return axios.post(url, tripletexAccount,{
            headers: basicAuth });
    }

    getTripletexAccountSettings(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/getAccountSettings' + '?merchant=' + user.merchant  + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editTripletexAccountSettings(accountSettings){
        let url = '/api/tripletex/editAccountSettings';
        let basicAuth = authHeader();
        return axios.post(url, accountSettings,{
            headers: basicAuth });
    }

    testTripletexConnection(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/testConnection' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    syncOrdersToTripletex(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/syncOrders' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    syncOrdersToUnimicro(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/syncOrders' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getTripletexSyncStatus(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/getSyncStatus' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    syncProductsToTripletex(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/syncProducts' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    syncZReportToTripletex(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/syncZReport' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    validateZReportSync(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/validateZReportSync' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    searchZReportVouchers(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/searchZReportVouchers' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    deleteSingleVoucher(locationId, voucherId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/deleteSingleVoucher' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&voucherId=' + voucherId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    deleteZReportVouchers(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/deleteZReportVouchers' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    syncPaymentSettlements(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/syncPaymentSettlements' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    reconcilePaymentSettlements(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/reconcilePaymentSettlements' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    searchBankReconciliations(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/searchBankReconciliations' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    deleteBankReconciliation(locationId, reconciliationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/deleteBankReconciliation' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&reconciliationId=' + reconciliationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    listInvoiceCustomers(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/invoiceCustomer/list' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    createInvoiceCustomer(invoiceCustomer){
        let url = '/api/invoiceCustomer/create';
        let basicAuth = authHeader();
        return axios.post(url, invoiceCustomer, { headers: basicAuth });
    }

    editInvoiceCustomer(invoiceCustomer){
        let url = '/api/invoiceCustomer/edit';
        let basicAuth = authHeader();
        return axios.post(url, invoiceCustomer, { headers: basicAuth });
    }

    deleteInvoiceCustomer(invoiceCustomer){
        let url = '/api/invoiceCustomer/delete';
        let basicAuth = authHeader();
        return axios.post(url, invoiceCustomer, { headers: basicAuth });
    }

    getMerchantSetting(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/settings/getMerchantSetting' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    editMerchantSetting(merchantSetting){
        let url = '/api/settings/editMerchantSetting';
        let basicAuth = authHeader();
        return axios.post(url, merchantSetting,{
            headers: basicAuth });
    }

    // SMS 2FA per merchant (SUPER_ADMIN). Separate from editMerchantSetting on purpose: that one upserts
    // whatever JSON it is handed, and the page only holds the projected subset of merchant_setting.
    getSms2faStatus(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/superadmin/merchant/sms2faStatus?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    saveSms2faSetting(requireSms2fa){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/superadmin/merchant/sms2faSetting';
        let basicAuth = authHeader();
        return axios.post(url, { merchant: user.merchant, requireSms2fa: requireSms2fa }, { headers: basicAuth });
    }

    // CAGISTA's ISV fee for ONE merchant (SUPER_ADMIN), overriding the platform rates in VIVA Partner Config.
    // Its own endpoint and server-only document, never merchant_setting — the merchant's ADMIN can save that one.
    getVivaIsvFee(){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/superadmin/viva/isvFee?merchant=' + user.merchant, { headers: authHeader() });
    }

    /** Blank rate = the platform rate; both blank = the merchant has no rate of its own. */
    saveVivaIsvFee(web, terminal){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/superadmin/viva/isvFee', { merchant: user.merchant, web: web, terminal: terminal },
            { headers: authHeader() });
    }

    /** Every merchant with a rate of its own — listed on VIVA Partner Config. */
    getVivaIsvFeeOverrides(){
        return axios.get('/api/superadmin/viva/isvFeeOverrides', { headers: authHeader() });
    }

    // Every location whose tills and kiosks carry CAGISTA's ISV pair (its viva block), and whether it is the pair saved
    // in VIVA Partner Config; «Oppdater alle» rewrites the outdated ones from the saved config — nothing is sent.
    getVivaTillSetups(){
        return axios.get('/api/superadmin/viva/tillSetups', { headers: authHeader() });
    }

    updateAllVivaTillSetups(){
        return axios.post('/api/superadmin/viva/tillSetups/updateAll', {}, { headers: authHeader() });
    }

    // Unimicro
    getUnimicroAccount(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/getUnimicroAccount?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    /** Environment + server-client state + this location's activation state, for the Unimicro page. */
    getUnimicroStatus(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/status?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    /** «Fullfør aktivering» / «Sjekk status»: bind the activated company and set the purchase active. */
    activateUnimicro(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/unimicro/activate', { merchant: user.merchant, locationId }, { headers: authHeader() });
    }

    // Unimicro server client (SUPER_ADMIN, System → Config → Unimicro Config)
    getUnimicroConfig(){
        return axios.get('/api/superadmin/system/unimicroConfig', { headers: authHeader() });
    }

    saveUnimicroConfig(payload){
        return axios.post('/api/superadmin/system/unimicroConfig', payload, { headers: authHeader() });
    }

    testUnimicroConfig(){
        return axios.post('/api/superadmin/system/unimicroConfig/test', {}, { headers: authHeader() });
    }

    /**
     * SUPER_ADMIN override: set the purchase status locally, without telling Unimicro. The username
     * rides along so the server can say in the log who decided it.
     */
    setUnimicroPurchaseStatus(locationId, status){
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/unimicro/setPurchaseStatus',
            { merchant: user.merchant, locationId, status, user: user.username || '' },
            { headers: authHeader() });
    }

    disconnectUnimicro(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/disconnectUnimicro';
        return axios.post(url, { merchant: user.merchant, locationId: locationId }, { headers: authHeader() });
    }

    testUnimicroConnection(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/testConnection?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    getUnimicroAccountSettings(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/getAccountSettings?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    editUnimicroAccountSettings(settings){
        let url = '/api/unimicro/editAccountSettings';
        return axios.post(url, settings, { headers: authHeader() });
    }

    syncZReportToUnimicro(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/syncZReport?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    validateUnimicroZReportSync(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/validateZReportSync?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    searchUnimicroZReportJournalEntries(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/searchZReportJournalEntries?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    deleteUnimicroSingleJournalEntry(locationId, journalEntryId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/deleteSingleJournalEntry?merchant=' + user.merchant + '&locationId=' + locationId + '&journalEntryId=' + journalEntryId;
        return axios.get(url, { headers: authHeader() });
    }

    getTripletexDepartments(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/tripletex/getDepartments?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getUnimicroDepartments(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/getDepartments?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    deleteUnimicroZReportJournalEntries(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/unimicro/deleteZReportJournalEntries?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    // Fiken
    getFikenAccount(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/getFikenAccount?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    editFikenAccount(account){
        let url = '/api/fiken/editFikenAccount';
        return axios.post(url, account, { headers: authHeader() });
    }

    getFikenAuthorizationUrl(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/getAuthorizationUrl?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    testFikenConnection(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/testConnection?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    getFikenAccountSettings(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/getAccountSettings?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    editFikenAccountSettings(settings){
        let url = '/api/fiken/editAccountSettings';
        return axios.post(url, settings, { headers: authHeader() });
    }

    getFikenCompanies(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/getCompanies?merchant=' + user.merchant + '&locationId=' + locationId;
        return axios.get(url, { headers: authHeader() });
    }

    syncZReportToFiken(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/syncZReport?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    validateFikenZReportSync(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/validateZReportSync?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    searchFikenZReportJournalEntries(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/searchZReportJournalEntries?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    deleteFikenSingleJournalEntry(locationId, transactionId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/deleteSingleJournalEntry?merchant=' + user.merchant + '&locationId=' + locationId + '&transactionId=' + transactionId;
        return axios.get(url, { headers: authHeader() });
    }

    deleteFikenZReportJournalEntries(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/deleteZReportJournalEntries?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }

    syncOrdersToFiken(locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/fiken/syncOrders?merchant=' + user.merchant + '&locationId=' + locationId + '&fromDate=' + fromDate + '&toDate=' + toDate;
        return axios.get(url, { headers: authHeader() });
    }
}

export default new SettingsService();
